import React from 'react';
import ReactDOM from 'react-dom/client';
import { ExpertPlatformIndexPage } from './ExpertPlatformIndexPage';
import { ExpertPlatformIndex } from './IExpertPlatformIndex';
import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: ExpertPlatformIndex;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const { data } = window as unknown as WindowWithData;

root.render(
  <React.StrictMode>
    <ExpertPlatformIndexPage {...data} />
  </React.StrictMode>
);
